import { createStandardAction } from 'typesafe-actions';
import * as Types from './types';
import { AuthenticationModalPayload, SocialVendor } from 'components/authentication/types';
import { FeedbackToastMessage } from 'components/feedback-toast/ToastContainer';
import {
  IFavoritesToggle,
  MutationOptionsMeta,
  MutationType,
  ISavedAddressToggle,
  ILoginWithEmailAndPasswordVariables,
  SavedAddressSettings,
  IUpdateSaveSearch,
  ToggleAddressMeta,
  ISignInSignUpWithEmailVariables,
  IFavoritesToggleMeta,
  IConsent,
  IUserAuthEventDataVariables,
} from 'store/sagas/apiService/types';
import { CommutePopupStatus } from 'components/commute-popup/types';
import { PopupImageGalleryStatus } from 'components/unit-page/gallery/Gallery';
import {
  ContactModalOpenMeta,
  SaveSearchUserAction,
  AuthModalSource,
  FinishFormState,
  TabuDictionary,
  ManageListingsErrorModal,
  DeveloperFiltersState,
  PushNotificationsModalType,
  DevicePushStatus,
  ContactAgentModalSource,
  AgentSupportModalVariant,
  PrivateUserMonetizationSource,
  InvestorsFeedbackModalState,
  PaymentMethod,
  AfterUploadBulletinModalState,
  AfterDeleteListingModalState,
} from './';
import {
  CommutePreference,
  ISendFeedbackCallbackProps,
  PoiId,
  SaveSearchMeta,
  SaveSearchPayload,
} from 'utils/entities';
import { Section } from 'components/navigation/subheader/SectionsNavigation';
import { FixedMultiPreviewStatus } from 'components/map/Preview/MultiListingPreview';
import { ShareModalType } from 'components/share-modal';
import {
  SubmitContactAgentPayload,
  SetMadadContactModalStatePayload,
} from './payloads';
import { SortDirection, SortField } from 'components/listing-sort/types';
import { RoomOption } from 'components/filters/types';
import { SearchViewMode } from 'components/list-view-switcher/constants';
import { FullPoiType } from 'components/inner-contact-form/mortgage-form/modeB';
import { IDealAffiliationPopupState } from 'components/deal-affiliation-popup/types';
import { IShareClosedDealPopupState } from 'components/agent-console/deals/share-closed-deal-popup/types';
import { NotificationBannerMessage } from 'components/notification-banner/types';
import { SavedSearchActiveModal } from 'components/saved-search/shared/active-modal';
import { InvestorSection } from 'screens/Investors/components/Subheader/config';
import { ICompareModalProps } from 'screens/Investors/components/CompareModal/types';
import { IUpdateListingStatusModal } from 'components/update-listing-status-popup/types';
import { IUploadBulletinReportModalState } from 'components/upload-bulletin/report-error-popup/interfaces';
import { INITIATE_SOURCE } from 'components/private-bulletin-promotion/types';
import { HostedFieldsErrors, TranzilaModalState } from 'components/tranzila-hosted-fields/types';

export const logout = createStandardAction(Types.LOGOUT)();
export const continueEditing = createStandardAction(Types.CONTINUE_EDITING)();
export const editLater = createStandardAction(Types.GET_BACK_TO_EDITING_LATER)();
export const setToastMessage = createStandardAction(Types.SET_TOAST_MESSAGE)<FeedbackToastMessage>();
export const setAuthModal = createStandardAction(Types.SET_AUTH_MODAL)<AuthenticationModalPayload, { isUserInitiated?: boolean, source?: AuthModalSource }>();
export const setInvestorsLoginStep = createStandardAction(Types.SET_INVESTORS_LOGIN_STEP)<AuthenticationModalPayload, { isUserInitiated?: boolean, source?: AuthModalSource }>();
export const userLoginSocial = createStandardAction(Types.USER_LOGIN_SOCIAL)<SocialVendor>();
export const signInSignUpWithEmail = createStandardAction(Types.SIGN_IN_SIGN_UP_WITH_EMAIL)<ISignInSignUpWithEmailVariables>();
export const setUserAuthEventData = createStandardAction(Types.SET_USER_AUTH_EVENT_DATA)<IUserAuthEventDataVariables>();
export const resetUserAuthEventData = createStandardAction(Types.RESET_USER_AUTH_EVENT_DATA)();
export const userLoginWithEmailAndPassword = createStandardAction(Types.USER_LOGIN_WITH_EMAIL_AND_PASSWORD)<ILoginWithEmailAndPasswordVariables>();
export const updateUser = createStandardAction(Types.UPDATE_USER)<MutationOptionsMeta<MutationType.UpdateUserProfile>>();
export const loginGoogleWithConsents = createStandardAction(Types.GOOGLE_LOGIN_WITH_CONSENTS)<IConsent[]>();
export const setInvestorsFeedbackModalStateAction = createStandardAction(Types.SET_INVESTORS_FEEDBACK_MODAL_STATE)<InvestorsFeedbackModalState>();
export const loginFacebookWithConsents = createStandardAction(Types.FACEBOOK_LOGIN_WITH_CONSENTS)<IConsent[]>();
export const loginWithPasswordAndConsents = createStandardAction(Types.PASSWORD_LOGIN_WITH_CONSENTS)<IConsent[]>();
export const setCommutePopupStatus = createStandardAction(Types.SET_COMMUTE_POPUP_STATUS)<CommutePopupStatus>();
export const setMobileDiscoveryPopupStatus = createStandardAction(Types.SET_MOBILE_DISCOVERY_POPUP_STATUS)<boolean>();
export const setContactAgentOpen = createStandardAction(Types.SET_CONTACT_AGENT_OPEN)<PoiId, ContactModalOpenMeta>();
export const setIntentModalOpen = createStandardAction(Types.SET_INTENT_MODAL_OPEN)<PoiId, ContactModalOpenMeta>();
export const setWelcomeModalOpen = createStandardAction(Types.SET_WELCOME_MODAL_OPEN)<PoiId, ContactModalOpenMeta>();
export const contactAgentInputClick = createStandardAction(Types.CONTACT_AGENT_INPUT_CLICK)<{ eventName: string; poi: FullPoiType }>();
export const setFeedbackPopupOpen = createStandardAction(Types.SET_FEEDBACK_POPUP_OPEN)<ISendFeedbackCallbackProps>();
export const setReportListingPopupOpen = createStandardAction(Types.SET_REPORT_LISTING_POPUP_OPEN)<boolean>();
export const setAddressFeedbackPopupOpen = createStandardAction(Types.SET_ADDRESS_FEEDBACK_POPUP_OPEN)<boolean>();
export const setReportUploadBulletinPopupState = createStandardAction(Types.SET_UPLOAD_BULLETIN_REPORT_MODAL_STATE)<IUploadBulletinReportModalState>();
export const setAfterUploadBulletinModalOpen = createStandardAction(Types.SET_AFTER_UPLOAD_BULLETIN_MODAL_OPEN)<AfterUploadBulletinModalState>();
export const setNeedsPopupOpen = createStandardAction(Types.SET_NEEDS_POPUP_OPEN)<boolean>();
export const setUserMobileProfileOpen = createStandardAction(Types.SET_USER_MOBILE_PROFILE_OPEN)<boolean>();
export const setUserMobileProfileReturnable = createStandardAction(Types.SET_USER_MOBILE_PROFILE_RETURNABLE)<boolean>();
export const setSidebarOpen = createStandardAction(Types.SET_SIDEBAR_OPEN)<boolean>();
export const setFinishFormState = createStandardAction(Types.SET_FINISH_FORM_STATE)<Partial<FinishFormState>>();
export const setContactAgentSuccessPoiId = createStandardAction(Types.SET_CONTACT_AGENT_SUCCESS_OPEN)<PoiId>();
export const showContactPhone = createStandardAction(Types.SHOW_CONTACT_PHONE)<boolean>();
export const submitContactAgent = createStandardAction(Types.SUBMIT_CONTACT_AGENT)<SubmitContactAgentPayload>();
export const submitUserContactAgent = createStandardAction(Types.SUBMIT_USER_CONTACT_AGENT)<SubmitContactAgentPayload>();
export const setShareModalOpen = createStandardAction(Types.SET_SHARE_MODAL_OPEN)<ShareModalType>();
export const setUpdateListingStatusModal = createStandardAction(Types.SET_UPDATE_LISTING_STATUS_MODAL_TYPE)<IUpdateListingStatusModal>();
export const toggleLoginSuccessModal = createStandardAction(Types.TOGGLE_LOGIN_SUCCESS)<boolean>();
export const setGALoadTimestamp = createStandardAction(Types.SET_GA_LOAD_TIMESTAMP)<number>();
export const setUnapprovedAgentPopupStatus = createStandardAction(Types.SET_UNAPPROVED_AGENT_POPUP_STATUS)<boolean>();

export const setGalleryStatus = createStandardAction(Types.SET_GALLERY_STATUS)<PopupImageGalleryStatus>();
export const setFixedMultiPreview = createStandardAction(Types.SET_FIXED_MULTI_PREVIEW)<FixedMultiPreviewStatus>();

export const saveSearch = createStandardAction(Types.SAVE_SEARCH)<SaveSearchPayload, SaveSearchMeta>();
export const saveSearchWithValidation = createStandardAction(Types.SAVE_SEARCH_WITH_VALIDATION)<SaveSearchPayload, SaveSearchMeta>();
export const updateSaveSearch = createStandardAction(Types.UPDATE_SAVED_SEARCH)<IUpdateSaveSearch>();
export const updateSaveSearchFrequency = createStandardAction(Types.UPDATE_SAVED_SEARCH_FREQUENCY)<IUpdateSaveSearch>();
export const deleteSaveSearch = createStandardAction(Types.DELETE_SAVE_SEARCH)<string, DeleteSaveSearchMeta>();
export const setSaveSearchModalOpen = createStandardAction(Types.SET_SAVE_SEARCH_MODAL_OPEN)<boolean>();
export type ResolveSaveSearchModalPayload = { userAction: SaveSearchUserAction.ChangeSearchArea, docId: string }
  | { userAction: SaveSearchUserAction.Reject }
  | { userAction: SaveSearchUserAction.Accept };
export const resolveSaveSearchModal = createStandardAction(Types.RESOLVE_SAVE_SEARCH_MODAL)<ResolveSaveSearchModalPayload>();

export const toggleFavorites = createStandardAction(Types.TOGGLE_FAVORITES)<IFavoritesToggle, IFavoritesToggleMeta>();
export const toggleAddress = createStandardAction(Types.TOGGLE_ADDRESS)<ISavedAddressToggle, ToggleAddressMeta>();

export const updatePendingAddressCardSettings = createStandardAction(Types.UPDATE_PENDING_ADDRESS_CARD_SETTINGS)<SavedAddressSettings>();

export const setMobileSearchMapViewActive = createStandardAction(Types.SET_MOBILE_SEARCH_MAP_VIEW_ACTIVE)<boolean>();
export const setVisibleSection = createStandardAction(Types.SET_VISIBLE_SECTION)<Section>();

export const setSaveAgentResultPopupOpen = createStandardAction(Types.SET_SAVE_AGENT_RESULT_POPUP_OPEN)<boolean>();
export const setTabuState = createStandardAction(Types.SET_TABU_STATE)<TabuDictionary>();
export const requestTabuByDocId = createStandardAction(Types.REQUEST_TABU_BY_DOC_ID)();

export const contactModalCall = createStandardAction(Types.CONTACT_MODAL_CALL)();

export const setMadadContactModalState = createStandardAction(Types.SET_MADAD_CONTACT_MODAL_STATE)<SetMadadContactModalStatePayload>();

export const setAuthEmail = createStandardAction(Types.SET_AUTH_EMAIL)<string>();
export const setManageListingsErrorModal = createStandardAction(Types.SET_MANAGE_LISTINGS_ERROR_MODAL)<ManageListingsErrorModal>();
export const closeManageListingsErrorModal = createStandardAction(Types.CLOSE_MANAGE_LISTINGS_ERROR_MODAL)<{ noRedirect?: boolean; }>();
export const setManageListingsFilterAgentUserId = createStandardAction(Types.SET_MANAGE_LISTINGS_FILTER_AGENT_USER_ID)<string>();

export const setDeveloperFilters = createStandardAction(Types.SET_DEVELOPER_FILTERS)<DeveloperFiltersState>();
export const setIsListingAdditionalBannerClosed = createStandardAction(Types.SET_IS_LISTING_ADDITIONAL_BANNER_CLOSED)<boolean>();
export const setIsSearchResultAdditionalBannerClosed = createStandardAction(Types.SET_IS_SEARCH_RESULT_ADDITIONAL_BANNER_CLOSED)<boolean>();
export const setIsMobileMenuHidden = createStandardAction(Types.SET_IS_MOBILE_MENU_HIDDEN)<boolean>();

export const setContactFormEventsSource = createStandardAction(Types.SET_CONTACT_FORM_EVENTS_SOURCE)<ContactAgentModalSource>();

export const setIsListingsTableLoading = createStandardAction(Types.SET_IS_LISTINGS_TABLE_LOADING)<boolean>();

export const setIsMizrahiBankModalOpen = createStandardAction(Types.SET_IS_MIZRAHI_BANK_MODAL_OPEN)<boolean>();
export const setIsYieldTagModalOpen = createStandardAction(Types.SET_IS_YIELD_TAG_MODAL_OPEN)<string>();

export const setIsAgentOfficeContactPopupOpen = createStandardAction(Types.SET_AGENT_OFFICE_CONTACT_POPUP_OPEN)<boolean>();
export const setIsMortgageOfficeContactPopupOpen = createStandardAction(Types.SET_MORTGAGE_OFFICE_CONTACT_POPUP_OPEN)<boolean>();

export const setIsLikedToastOpen = createStandardAction(Types.SET_IS_LIKED_TOAST_OPEN)<boolean>();
export const setCommittedSearchViewMode = createStandardAction(Types.SET_COMMITTED_SEARCH_VIEW_MODE)<SearchViewMode>();
export const setIntermediateSearchViewMode = createStandardAction(Types.SET_INTERMEDIATE_SEARCH_VIEW_MODE)<SearchViewMode>();

export const setIsHeaderTabSubmenuVisible = createStandardAction(Types.SET_IS_HEADER_TAB_SUBMENU_VISIBLE)<boolean>();
export const setPushNotificationsModalType = createStandardAction(Types.SET_PUSH_NOTIFICATIONS_MODAL_TYPE)<PushNotificationsModalType>();
export const setDevicePushStatus = createStandardAction(Types.SET_DEVICE_PUSH_STATUS)<DevicePushStatus>();

export const setDealAffiliationPopup = createStandardAction(Types.SET_DEAL_AFFILIATION_POPUP)<IDealAffiliationPopupState>();
export const setShareClosedDealPopup = createStandardAction(Types.SET_SHARE_CLOSED_DEAL_POPUP)<IShareClosedDealPopupState>();

export const setListingEdited = createStandardAction(Types.SET_LISTING_EDITED)<number>();
export const setNewUnitPageMapExpanded = createStandardAction(Types.SET_NEW_UNIT_PAGE_MAP_EXPANDED)<boolean>();
export const setMobileDiscoveryDisabled = createStandardAction(Types.SET_MOBILE_DISCOVERY_DISABLED)();
export const setMobileDiscoveryEnabled = createStandardAction(Types.SET_MOBILE_DISCOVERY_ENABLED)();

export const openAgentSupportModal = createStandardAction(Types.OPEN_AGENT_SUPPORT_MODAL)<{ variant: AgentSupportModalVariant }>();
export const closeAgentSupportModal = createStandardAction(Types.CLOSE_AGENT_SUPPORT_MODAL)();

export const initiatePayment = createStandardAction(Types.INITIATE_PAYMENT)<{ productId: string; redirectUrl: string; initiateSource: INITIATE_SOURCE; bulletinsId: string | null }>();

export const setPrivateUserMonetizationEventsSource = createStandardAction(Types.SET_PRIVATE_USER_MONETIZATION_EVENTS_SOURCE)<PrivateUserMonetizationSource>();

export const fetchSoldDealBannerDataAction = createStandardAction(Types.FETCH_SOLD_DEAL_BANNER_DATA)<{ agentId: string; officeId: string }>();
export const resetSoldDealBannerDataAction = createStandardAction(Types.RESET_SOLD_DEAL_BANNER_DATA)();

export const setNotificationBannerMessage = createStandardAction(Types.SET_NOTIFICATION_BANNER_MESSAGE)<NotificationBannerMessage>();
export const setMenuDotVisible = createStandardAction(Types.SET_MENU_DOT_VISIBLE)<boolean>();
export const setSavedSearchActiveModal = createStandardAction(Types.SET_SAVED_SEARCH_ACTIVE_MODAL)<SavedSearchActiveModal | null>();

export const setInvestorsSubheaderActiveSectionAction = createStandardAction(Types.SET_INVESTORS_SUBHEADER_ACTIVE_SECTION)<InvestorSection>();
export const setInvestorsCompareModalAction = createStandardAction(Types.SET_INVESTORS_COMPARE_MODAL_OPEN)<ICompareModalProps>();
export const setInvestorsRecentSearchIdAction = createStandardAction(Types.SET_INVESTORS_RECENT_SEARCH_ID)<string>();

export const setCookieConsentModalAction = createStandardAction(Types.SET_COOKIE_CONSENT_MODAL_OPEN)<boolean>();

export const setHostedFieldsModalAction = createStandardAction(Types.SET_HOSTED_FIELDS_MODAL_STATE)<TranzilaModalState | null>();
export const setHostedFieldsFailModalAction = createStandardAction(Types.SET_HOSTED_FIELDS_FAIL_MODAL)<boolean>();
export const setHostedFieldsFailUploadModalAction = createStandardAction(Types.SET_HOSTED_FIELDS_FAIL_UPLOAD_MODAL)<boolean>();
export const setHostedFieldsSuccessModalAction = createStandardAction(Types.SET_HOSTED_FIELDS_SUCCESS_MODAL)<boolean>();
export const setHostedFieldsSuccessUploadModalAction = createStandardAction(Types.SET_HOSTED_FIELDS_SUCCESS_UPLOAD_MODAL)<boolean>();
export const submittedPaymentViaHostedFieldsAction = createStandardAction(Types.SUBMITTED_PAYMENT_VIA_HOSTED_FIELDS)<{ method: PaymentMethod; paymentId: string; }>();
export const pendingTranzilaHostedFieldsModalAction = createStandardAction(Types.TRANZILA_HOSTED_FIELDS_PENDING_PAYMENT)<{ paymentId: string; }>();
export const setTranzilaHostedFieldsModalErrorsAction = createStandardAction(Types.SET_HOSTED_FIELDS_MODAL_ERRORS_STATE)<HostedFieldsErrors>();
export const setHostedFieldsGoogleEnableAction = createStandardAction(Types.SET_HOSTED_FIELDS_GOOGLE_ENABLE_BUTTON)<boolean>();
export const setAfterListingDeleteModalOpen = createStandardAction(Types.SET_AFTER_LISING_DELETE_MODAL_OPEN)<AfterDeleteListingModalState>();

export * from './private-user-monetization/actions';

export enum ViewTypes {
  Needs = 'Needs',
  Commute = 'Commute',
  PriceAndBedrooms = 'PriceAndBedrooms',
  Price = 'Price',
  Bedrooms = 'Bedrooms',
}

interface DeleteSaveSearchMeta {
  source: 'search_result_page' | 'saved_searches_page';
}

export interface Payload {
  activeView: ViewTypes;
  priorities: Array<[ SortField, SortDirection ]>;
  commutePreference: CommutePreference;
  priceRange: [number, number];
  roomsRange: [RoomOption, RoomOption];
}
